module.exports = __webpack_public_path__ + "static/media/delete.6d393e37.svg";